import '../utils/axiosConfig';
import { BrowserRouter as Router, Route, Routes,Navigate, useNavigate} from 'react-router-dom';
import React, { useEffect } from 'react';
import Register from './Register';
import Login from './Login';
import Home from './Home';
import Navbar from './Navbar';
import Profile from './Profile';
import PaymentPage from './PaymentPage';
import InvesteeMatchForm from './InvesteeMatchForm';
import AboutUs from './AboutUs';
import ProgrammesPage from './ProgrammesPage';
import ProgrammesPageOnLogin from './ProgrammesPageOnLogin';
import InvestorPage from './InvestorPage';
import InvesteePage from './InvesteePage';
import EmailVerification from './EmailVerification';
import ResetPasswordPage from './ResetPasswordPage';
import EventPage from './EventPage';
import PrivacyPolicy from './PrivacyPolicy';
import DeleteAccount from './DeleteAccount';
import ResetPasswordConfirmPage from './ResetPasswordConfirmPage';
import VerifyEmailPage from './VerifyEmailPage';
import SupportPage from './SupportPage';
import TrainingCalendarPage from './TrainingCalendarPage';
import EventsCalendarPage from './EventsCalendarPage';
import InsightsPage from './InsightsPage';
import ContactPage from './ContactPage';
import SessionTimeout from './SessionTimeout';
import ProtectedRoute from './ProtectedRoute';
import ChangePasswordPage from './ChangePasswordPage';
import FloatingContact from './FloatingContact';
import ErrorBoundary from './ErrorBoundary';


const App = () => {
  const token = localStorage.getItem('token');

// App.js (only showing the parts that change)

function AuthSync() {
  const navigate = useNavigate();
 // inside AuthSync in App.js
useEffect(() => {
  const isPublicPath = (path) => {
    // exact public pages
    if ([
      '/', '/login', '/register', '/about', '/programs', '/insights', '/contact',
      '/reset-password', '/support', '/privacy-policy', '/emailVerification'
    ].includes(path)) return true;

    // dynamic public pages
    if (path.startsWith('/reset-password-confirm/')) return true;
    if (path.startsWith('/verify-email/')) return true;

    return false;
  };

  const sync = () => {
    const hasToken = !!localStorage.getItem('token');
    const path = window.location.pathname;
    if (!hasToken && !isPublicPath(path)) {
      // send anonymous visitors to HOME, not /login
      navigate('/', { replace: true });
    }
  };

  sync();
  const onStorage = (e) => {
    if (!e || ['token', 'user_type', 'logout_at'].includes(e.key)) sync();
  };
  window.addEventListener('storage', onStorage);
  window.addEventListener('focus', sync);
  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener('focus', sync);
  };
}, [navigate]);

  return null;
}



  // Listen for storage changes to handle logout across tabs
  // This ensures if the token is removed in another tab, this tab redirects to login
  useEffect(() => {
  const onStorage = (e) => {
    if (e.key === 'token' || e.key === 'user_type' || e.key === 'logout_at') {
      // if token removed in another tab, kick this tab to login
      if (!localStorage.getItem('token')) {
        window.location.pathname !== '/login' && (window.location.href = '/login');
      }
    }
  };
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}, []);

  // Render the app with routes
  return (
    
      <Router>
      {/* start inactivity logout only when logged in */}
      {token && <SessionTimeout timeout={30 * 60 * 1000} />}
      
      <Navbar />
      <AuthSync />
      <FloatingContact />
      <ErrorBoundary>
      <Routes>
          {/* Public Routes */}
        <Route path="/"                   element={<Home />} />
        <Route path="/register"           element={<Register />} />
        <Route path="/login"              element={<Login />} />
        <Route path="/about"              element={<AboutUs />} />
        <Route path="/programs"           element={<ProgrammesPage />} />
        <Route path="/insights"           element={<InsightsPage />} />
        <Route path="/contact"            element={<ContactPage />} />
        <Route path="/profile"            element={<ProtectedRoute allowedRoles={['investor', 'investee']}><Profile /></ProtectedRoute>} />
        <Route path="/delete-account"     element={<ProtectedRoute allowedRoles={['investor', 'investee']}><DeleteAccount /></ProtectedRoute>} />
        <Route path="/training-calendar" element={<ProtectedRoute allowedRoles={['investor','investee']}><TrainingCalendarPage /></ProtectedRoute>} />
        <Route path="/events-calendar" element={<ProtectedRoute allowedRoles={['investor','investee']}><EventsCalendarPage /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute allowedRoles={['investor','investee']}><ChangePasswordPage /></ProtectedRoute>} />
        <Route path="/event-calendar" element={<ProtectedRoute allowedRoles={['investor','investee']}><EventPage /></ProtectedRoute>} />
        <Route path="/programs-loggedIn" element={<ProtectedRoute allowedRoles={['investor','investee']}><ProgrammesPageOnLogin /></ProtectedRoute>} />
        <Route path="/payment-page" element={<ProtectedRoute allowedRoles={['investor','investee']}><PaymentPage /></ProtectedRoute>} />
        {/* Mixed: same component but protected view */}
        <Route path="/programs-loggedIn"  element={<ProgrammesPageOnLogin />}/>
        <Route path="/investor-page"element={<ProtectedRoute allowedRoles={['investor']}> <InvestorPage /></ProtectedRoute>}/>
        <Route path="/investee-page"element={<ProtectedRoute allowedRoles={['investee']}> <InvesteePage /></ProtectedRoute> }/>
        <Route path="/reset-password"     element={<ResetPasswordPage />} />
        <Route path="/reset-password-confirm/:uid/:token" element={<ResetPasswordConfirmPage />} />
        <Route path="/emailVerification"  element={<EmailVerification />} />
        <Route path="/verify-email/:uidb64/:token" element={<VerifyEmailPage />} />
        <Route path="/support"            element={<SupportPage />} />
        <Route path="/privacy-policy"     element={<PrivacyPolicy />} />
     
         {/* Critical Protected Routes */}

        <Route path="/investee-match"
               element={<ProtectedRoute allowedRoles={['investee']}><InvesteeMatchForm /></ProtectedRoute>} />

         {/* Catch-all: redirect based on login state */}
        <Route
          path="*"
          element={<Navigate to={token ? "/" : "/login"} replace />}
        />
      </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;
